import { FC, useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { LoginCodeStep } from './LoginCodeStep';
import { LoginMembershipID } from './LoginEmailStep';

export type LoginFormStep = 'membershipId' | 'code';

export interface LoginFormFields {
  code: string;
  membershipId: string;
}

interface Props {
  onChangeStep(step: LoginFormStep): void;
}

export const LoginForm: FC<Props> = ({ onChangeStep }) => {
  const [step, setStep] = useState<LoginFormStep>('membershipId');
  const form = useForm<LoginFormFields>({
    defaultValues: {
      code: '',
      membershipId: '',
    },
  });

  useEffect(() => {
    onChangeStep(step);
  }, [onChangeStep, step]);

  return (
    <FormProvider {...form}>
      {step === 'membershipId' ? (
        <LoginMembershipID onSuccess={() => setStep('code')} />
      ) : (
        <LoginCodeStep />
      )}
    </FormProvider>
  );
};
